import { Action, createReducer, on } from '@ngrx/store';

import { GlobalPermAction } from '../actions';
import { GlobalPermState } from '../states/perm.state';

const initialState: GlobalPermState = {
  permissions: []
};

const authReducer = createReducer(
  initialState,
  on(GlobalPermAction.SetPermission, (state, { permissions }) => ({
    ...state,
    permissions,
  })),
  on(GlobalPermAction.ResetAll, () => initialState)
);

export function GlobalPermReducer(state: GlobalPermState | undefined, action: Action) {
  return authReducer(state, action);
}
